import "../privacyCentre.css";

export default function CookiePolicy() {
	return (
		<>
			<h2 className="pc-page-title">Cookie Policy</h2>
			<h3 className="pc-section-title">What is a Cookie?</h3>
			<p className="pc-detail-text">
				Cookies are small text files, created by the website visited, that contain data. They are stored on the
				visitor's computer to give the user access to various functions. Both session cookies and non-session
				cookies are used on this website (the “Site”). A session cookie is temporarily stored in the computer
				memory while the visitor is browsing the website. This cookie is erased when the user closes their web
				browser or after a certain time has passed (meaning that the session expires). A non-session cookie
				remains on the visitor's computer until it is deleted.
			</p>
			<h3 className="pc-section-title">Why do we use Cookies?</h3>
			<p className="pc-detail-text">
				We use cookies to learn more about the way visitors interact with our content and help us to improve the
				experience when visiting our Site.
			</p>
			<h3 className="pc-section-title">Site Functionality</h3>
			<p className="pc-detail-text">
				Some functionality is used by visitors, for example, to recommend our Site and content on social
				networks such as Facebook and Twitter. Cookies store information on how visitors use the share function
				- although not at an individual level - so that the Site can be improved. If you do not accept cookies,
				no information is stored. For some of the functions within our Site we use third party suppliers, for
				example, when you visit a page with videos embedded from or links to YouTube. These videos or links (and
				any other content from third party suppliers) may contain third party cookies and you may wish to
				consult the policies of these third party websites for information regarding their use of cookies.
			</p>
			<h3 className="pc-section-title">Cookies we Use:</h3>
			<p className="pc-detail-text">
				This Site uses The Spotify Web API, which uses cookies, and we also store a cookie to verify your
				identity, to make it easier to stay logged into the site. At the aggregate level, cookies store
				information on how visitors use the Site, including the number of pages displayed, where the visitor
				comes from, and the number of visits, to improve the website and ensure a good user experience. If you
				do not accept cookies, no information is stored.
			</p>
			<h3 className="pc-section-title">How to reject Cookies?</h3>
			<p className="pc-detail-text">
				We will not use cookies to collect personally identifiable information about a visitor. However you can
				choose to reject or block the cookies set by <em>SpotLite</em> by changing your browser settings - see
				the “Help function” within your browser for further details. Please note that most browsers
				automatically accept cookies so if you do not wish cookies to be used, you may need to actively delete
				or block the cookies. For information on the use of cookies in mobile phone browsers and for details on
				how to reject or delete such cookies, please refer to your mobile phone manual.
			</p>
		</>
	);
}
